import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { EditalService } from '../../service/edital/edital.service';
import * as  moment from 'moment';
import { EditalDTO } from '../../model/dto/edital.dto';
import { DataTransferService } from '../../service/data-transfer.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DocumentoDTO } from 'src/app/model/dto/documento.dto';
import { DocumentoService } from 'src/app/service/documento.service';
import { ToasterService } from 'angular2-toaster';

const ELEMENT_DATA: EditalDTO[] = [];

@Component({
  selector: 'app-modal-atualizacao-form',
  templateUrl: './modal-atualizacao-form.component.html',
  styleUrls: ['./modal-atualizacao-form.component.css']
})
export class ModalAtualizacaoFormComponent implements OnInit {

  editalForm: FormGroup

  mensagem: string;
  date: string;
  id: number;
  edital:EditalDTO;
  anexo: File;
  anexo64: String;
  arquivo: DocumentoDTO;

  constructor( public dialogRef: MatDialogRef<ModalAtualizacaoFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private fb: FormBuilder,
    private editalService: EditalService,
    private dataTransfer: DataTransferService,
    private toastService: ToasterService) {}

  ngOnInit() {
    this.montarForm();
  }

  montarForm(){
      this.editalForm = this.fb.group({
        nomeEdital: new FormControl(''),
        periodoInicio: new FormControl(''),
        periodoFim: new FormControl(''),
        dataLancamento: new FormControl(''),
      });
    
    this.preencherCampos(this.data.edital);
  }

  async preencherCampos(edital: EditalDTO) {     
    
    const existe = await this.editalService.verificarInscritos(edital.id);
    this.editalForm.get('nomeEdital').setValue(edital.nomeEdital);
    this.editalForm.get('periodoInicio').setValue(moment(edital.periodoInicio).locale('en').format());
    this.editalForm.get('periodoFim').setValue(moment(edital.periodoFim).locale('en').format());
    this.editalForm.get('dataLancamento').setValue(moment(edital.dataDistribuicao).locale('en').format());
    if(!existe) {
      this.editalForm.get('nomeEdital').disable();
      this.editalForm.get('periodoInicio').disable();
      this.editalForm.get('dataLancamento').disable();
    }
    
    this.arquivo = edital.documento;    
  }


  confirmar() {

    if (!this.editalForm.valid) {
      Swal.fire({
        text: 'Preencha todos os campos para finalizar o cadastro',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        icon: 'info',
      });
      return;
    }

    if (this.anexo == null && this.arquivo == null) {
      Swal.fire({
        text: 'É necessário anexar um arquivo para finalizar o cadastro',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        },
        icon: 'info',
      });
      return;
    }

    const edital = new EditalDTO();
    edital.id = this.data.edital.id
    edital.nomeEdital = this.editalForm.get('nomeEdital').value;
    edital.periodoInicio = moment(this.editalForm.get('periodoInicio').value).format('YYYY-MM-DD');
    edital.periodoFim = moment(this.editalForm.get('periodoFim').value).format('YYYY-MM-DD');
    edital.dataDistribuicao = moment(this.editalForm.get('dataLancamento').value).format('YYYY-MM-DD');
    edital.anexoEdital = this.anexo64;
    edital.documento = this.arquivo;
    edital.nomeAnexo = this.anexo ? this.anexo.name : this.arquivo.nome;
    
    this.editalService.atualizar(edital).subscribe(({ data }) =>{
      if (data !== null) {
        Swal.fire({text: 'Atualizado com sucesso',
          icon: 'success',
        });
      }
      this.dialogRef.close(true);   
    },
    error => {
      if(error.status == 400){
        Swal.fire({
          text:  'Não foi possível atualizar o Edital.',
          icon: 'error',
        });  
      } 
    });
  }

  cancelar(): void {
    this.dialogRef.close();  
  }

  selecionarAnexo(event) {
    this.anexo = event.target.files[0]; 

    if (this.anexo.type != 'application/pdf') {
      this.toastService.pop('warning', 'Formato inválido. Formato permitido PDF');
      this.anexo = null;
      return;
    }

    if (this.anexo.size > 5000000) {
      this.toastService.pop('warning', 'Tamanho do anexo excede o limite permitido');
      this.anexo = null;
      return;
    }

    this.encodeAnexo(this.anexo);
    this.arquivo = new DocumentoDTO();
    this.arquivo.nome = this.anexo.name;
    (event.target as HTMLInputElement).value = null;
  }

  desanexarArquivo() {
    this.arquivo = null;
    this.anexo64 = null;
  }

  private encodeAnexo(anexo : File) {
    var rd = new FileReader();  
    if (anexo != null && anexo != undefined) {

      rd.readAsDataURL(anexo);
      rd.onload = () => {
        this.anexo64 = rd.result.toString().split(',')[1];
      }

      rd.onerror = (error) => {
        this.anexo64 = "";
      }
    }
  }

}
